// Org-scoped roles: require an organizationId at invite time and get a membership row.
export const ORG_SCOPED_ROLES = ["practice_admin", "pcp", "clinical_support_staff"];
// Internal TeleCurb staff roles: no mandatory org membership.
// Only platform_admin can invite these.
export const INTERNAL_STAFF_ROLES = ["specialist", "consult_curator"];
// Org-optional roles: internal staff that may optionally be credentialed to one or more orgs.
export const ORG_OPTIONAL_ROLES = ["consult_curator"];
// platform_admin is invitable too (TEL-171) — but only by another platform_admin
// (enforced in invite.service), takes no org/specialty, and still requires
// accept-invite + MFA enrollment. The *first* platform admin is still bootstrapped
// out-of-band via seed-platform-admin; this just lets admins add peers in-app.
export const INVITABLE_ROLES = [
    ...ORG_SCOPED_ROLES,
    ...INTERNAL_STAFF_ROLES,
    "platform_admin",
];
// 8-state consult lifecycle. Keep in sync with the DB-level CHECK constraint at
// packages/db/src/schema.ts (CONSULT_STATUSES). Defined here so packages that
// can't depend on @telecurb/db (e.g. @telecurb/shared) have access to the enum.
export const CONSULT_STATUSES = [
    "draft",
    "submitted",
    "assigned",
    "accepted",
    "answered",
    "follow-up-active",
    "clarification-requested",
    "closed",
    "cancelled",
];
//# sourceMappingURL=types.js.map